'use client';
/* Built In Imports */
import { useEffect, useRef } from 'react';

/* External Imports */
import { ChakraProvider } from '@chakra-ui/react';
import TagManager from 'react-gtm-module';

/* Internal Imports */
/* Components */
import ILALayout from '@app-ila/components/Layout/Layout';
import BuildTimeComment from '@app-ila/components/Utility/BuildTimeComment';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import './globals-ila.css';
import { ishaTheme } from './theme.ila';
import { mixPanel } from '@utils/Mixpanel';
/* Services */
/* Styles */

// const nextBuildType = process?.env?.NEXT_PUBLIC_BUILDTYPE?.toUpperCase();
// const { buildType } = BUILD_TYPE_CONFIG;

/**
 * @param Component
 * @param pageProps
 */

const Providers = ({ children }) => {
  const firstUpdate = useRef(true);

  const tagManagerArgs = {
    gtmId: 'GTM-5G2NJ8P',
  };

  useEffect(() => {

    // Mixpanel
    const Mixpanel = mixPanel(
      window?.location.pathname,
      process?.env?.NEXT_PUBLIC_BUILDTYPE
    );

    if (Object.keys(Mixpanel)?.length > 0) {
      // console.log('mixpanel load starts', Mixpanel, window?.location.pathname);

      const mixPanelPageViewObj = {
        page_name: window?.document?.title,
      };

    // Track page views
    if (window?.location.pathname.startsWith('/sadhguru-academy')) {
      Mixpanel.track('sga_pageview', mixPanelPageViewObj);
    }
    }
    // Mixpanel

    setTimeout(function () {
      if (firstUpdate.current) {
        if (process.browser) {
          TagManager.initialize(tagManagerArgs);
        }
        firstUpdate.current = false;
      } else {
        // consoleLog('GTM pushed to data layer', window.location.href);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'Pageview',
          url: window.location.href,
          title: window.document.title,
        });
      }
    }, 1500);
  }, []);
  return (
    <>
      <ChakraProvider resetCSS theme={ishaTheme}>
        <ILALayout>{children}</ILALayout>
      </ChakraProvider>
      <BuildTimeComment />
    </>
  );
};

export default Providers;
